import React from 'react';
import 'semantic-ui-css/semantic.min.css';
import ReportModelBase from '../ReportModelBase';
import { Table } from 'semantic-ui-react';

class TenureReportModel extends ReportModelBase {

    constructor(props){
        super(props);
        this.searchUrl = "api/Reports/EmployeeTenureReport";
        this.title = "Employee Report Group by BirthMonth";
        this.exportToExcelUrl = "api/Reports/ExportEmployeeTenureReportToExcel";
        this.exportToPdfUrl = "api/Reports/ExportEmployeeTenureReportToPDF";
    }

    toTableRow = (rowData) => {
        return (
            <Table.Row>
                <Table.Cell>{rowData["Employee No"]}</Table.Cell>
                <Table.Cell>{rowData["Employee"]}</Table.Cell>
            </Table.Row>
        );
    }

    createColumnHeaders = () => {
        return (
            <Table.Row>
                <Table.HeaderCell>Employee No</Table.HeaderCell>
                <Table.HeaderCell>Employee</Table.HeaderCell>
            </Table.Row>
        );
    }

}
export default TenureReportModel;